import React from "react"
import { useTranslation } from "react-i18next"

import { IconSize } from "shared/types/Icon"
import { ProductInformation } from "shared/types/__generated__/graphql"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { ProductAccordionDimensioningContent } from "widgets/product-accordion/ui/ProductAccordionDimensioningContent"
import { PRODUCT_POSITION_TABLE_DIMENSIONING_HEADER_ID } from "widgets/product-position-table/ProductPositionTableHeader"

import { ProductPositionTableCell } from "../../ProductPositionTableCell"
import { ProductPositionRowCellProps } from "../product-position/ProductPositionTableProductPositionRowView"

interface ProductPositionRowDimensioningCellProps
  extends ProductPositionRowCellProps {
  productInformation: ProductInformation | null | undefined
}

export const ProductPositionRowDimensioningCell = React.memo(
  React.forwardRef(
    (
      { productInformation, ...rest }: ProductPositionRowDimensioningCellProps,
      ref: React.ForwardedRef<HTMLDivElement>
    ) => {
      const { t } = useTranslation()

      return (
        <ProductPositionTableCell
          aria-labelledby={PRODUCT_POSITION_TABLE_DIMENSIONING_HEADER_ID}
          className="dimensioning"
          data-testid="dimensioning-cell"
          ref={ref}
          tooltipClassName="table-row-cell__tooltip dimensioning"
          tooltip={
            productInformation?.dimensioning ? (
              <ProductAccordionDimensioningContent
                isTooltip
                externalDimensioning={productInformation?.dimensioning}
              />
            ) : null
          }
          {...rest}
        >
          {productInformation?.dimensioning ? (
            <Icon name={IconName.DIMENSIONING} size={IconSize.SMALL} />
          ) : (
            <div className="visually-hidden">
              {t("Product.Configuration.NoDimensioning")}
            </div>
          )}
        </ProductPositionTableCell>
      )
    }
  )
)
